/* 

Copyright© Celligence International, LLC - 2023

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

export const LocationParser = (obj) => {
  const city = obj?.zipcodeData?.cities?.[0]?.name
    ?.split(" ")
    .map((word) => capitalizationFixer(word))
    .join(" ");

  const state = obj?.zipcodeData?.state;
  const zipcode = obj?.zipcode;
  const region = obj?.userLocation?.timeZone?.split("/")?.[0];

  return [city, state, zipcode, region]
    .filter((value) => value !== null &&
                       value !== undefined &&
                       String(value).trim() !== "")
    .join(", ") || "";
};

export const BrowserParser = (obj) => {
  return `${obj.name} - version: ${obj.version}`;
};

export const OSParser = (obj) => {
  return `${obj.name} ${obj.version}`;
};

function capitalizationFixer(word) {
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}